import {
  EnrollmentCreateByEmailsDocument,
  EnrollSelfDocument,
  DeleteEnrollmentDocument,
  EnrollmentsDocument,
  SetEnrollmentAttendanceDocument,
  SetBulkEnrollmentAttendanceDocument,
} from '@/store/v2';
import { MutationTuple, QueryResult, useMutation, useQuery } from '@apollo/client';
import { getOperationName } from '@apollo/client/utilities';

import { AttendedType } from '@/types/learning';

export interface Enrollment {
  id: number;
  userId: number;
  enrolledAt: string;
  locationId: number;
  attended: AttendedType;
  user: {
    email: string;
    username: string;
    profileImage?: string;
  };
}

export const useEnrollmentCreateByEmails = (): MutationTuple<
  { enrollmentCreateByEmails: Enrollment[] },
  { input: { locationId: number; emails: string[] } }
> => {
  return useMutation(EnrollmentCreateByEmailsDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [getOperationName(EnrollmentsDocument)!],
  });
};

export const useEnrollSelf = (): MutationTuple<{ enrollSelf: Enrollment }, { input: { locationId: number } }> => {
  return useMutation(EnrollSelfDocument, { awaitRefetchQueries: true, refetchQueries: [getOperationName(EnrollmentsDocument)!] });
};

export const useDeleteEnrollment = (): MutationTuple<
  { deleteEnrollment: { id: unknown } },
  { input: { enrollmentId: number } }
> => {
  return useMutation(DeleteEnrollmentDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [getOperationName(EnrollmentsDocument)!],
  });
};

export const useEnrollments = (
  locationIds: number[],
  skip?: boolean,
): QueryResult<{ enrollments: Enrollment[] }, { input: { locationIds: number[] } }> => {
  return useQuery(EnrollmentsDocument, { variables: { input: { locationIds } }, skip });
};

export const useSetEnrollmentAttendance = (): MutationTuple<
  { setEnrollmentAttendance: Enrollment },
  { input: { enrollmentId: number; attended: AttendedType } }
> => {
  return useMutation(SetEnrollmentAttendanceDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [getOperationName(EnrollmentsDocument)!],
  });
};

export const useSetBulkEnrollmentAttendance = (): MutationTuple<
  { setEnrollmentAttendance: Enrollment },
  { input: { enrollmentId: number; attended: AttendedType }[] }
> => {
  return useMutation(SetBulkEnrollmentAttendanceDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [getOperationName(EnrollmentsDocument)!],
  });
};
